import { render, staticRenderFns } from "./CampoConfiguracion.vue?vue&type=template&id=a57a94b0&scoped=true"
import script from "./CampoConfiguracion.vue?vue&type=script&lang=js"
export * from "./CampoConfiguracion.vue?vue&type=script&lang=js"
import style0 from "./CampoConfiguracion.vue?vue&type=style&index=0&id=a57a94b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57a94b0",
  null
  
)

export default component.exports